import React, {useEffect, useCallback} from 'react'
import './pageStyles/home.min.css'
import Header from '../components/header/header'
import HeroDescription from '../components/heroDescription/index'
import CallToActionButton from '../components/callToActionButton/index'

const Home = () => {
  // This is to set the background coz i've been having some trouble setting the background of the various pages using CSS
  const desktopBG = "url('/assets/home/background-home-desktop.jpg')"
  const mobileBG = "url('/assets/home/background-home-mobile.jpg')"
  
  const memoizedScreenCheck = useCallback(() => {
    if (window.innerWidth < 1000) {
      document.body.style.backgroundImage = mobileBG
    } else {
      document.body.style.backgroundImage = desktopBG
    }
  }, [window.innerWidth])

  useEffect(() => {
    memoizedScreenCheck()
  }, [memoizedScreenCheck])

  return (
    <>
      <Header activeLink='1'/>
    <div className="container">
      <div className="MainContainer">
        <div className="MainChild">
          <HeroDescription
            mediumText='SO, YOU WANT TO TRAVEL TO'
            mainTextLarge='SPACE'
            description="Let's face it; you want to go to space, you might as well genuinly go to outer space and not hover kind of on the edge of it. We'll sit back, and relax because we'll give you a truly out of this world experience."
          />
        </div>
        <div className="center right-align" style={{ margin: '0 auto' }}>
          <CallToActionButton />
        </div>
      </div>
    </div>
    </>
  )
}

export default Home